import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import "./Details.css";
import { BsGithub } from "react-icons/bs";
import { MdLiveTv } from "react-icons/md";

const Details = () => {
  const [porject, setProject] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetch("../projects.json")
      .then((res) => res.json())
      .then((data) => {
        const one = data.find((p) => p.id === id);
        if (one) {
          setProject(one);
        }
      });
  }, [id]);

  const liveSite = {
    href: porject.live,
    target: "_blank",
  };

  const GithubSite = {
    href: porject.github,
    target: "_blank",
  };

  return (
    <div>
      <Header></Header>
      <div className="detail pt-10 lg:pt-16 px-3 lg:px-0">
        <div className="hero mt-5 bg- bg-gray-300 text-black p-5 rounded-md">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10">
            <img
              src={porject.img}
              className="w-full h-96 rounded-lg"
              alt="project img"
            />
            <img
              src={porject.img2}
              className="w-full h-96 rounded-lg"
              alt="project img"
            />
            <img
              src={porject.img3}
              className="w-full h-96 rounded-lg"
              alt="project img"
            />
          </div>
          <div className="hero-content md:flex lg:flex justify-between">
            {/* className='w-[100%] md:w-[30%] lg:w-[30%]' */}
            {/* <div>
                            <img src={porject.img} className="w-full h-96 rounded-lg" alt='project img' />
                        </div> */}

            {/* className='w-[100%] md:w-[65%] lg:w-[65%]' */}
            <div>
              <h1 className="text-3xl font-bold mt-2 lg:mt-0">
                {porject.name}
              </h1>
              <p className="py-6">{porject.discription}</p>
              <div className="flex">
                <a
                  className="text-black font-semibold flex items-center mr-5"
                  {...GithubSite}
                >
                  <BsGithub size={20} className="mr-1" />
                  <p>GitHub</p>
                </a>
                <a
                  className="text-indigo-600 font-semibold flex items-center"
                  {...liveSite}
                >
                  <MdLiveTv size={20} className="mr-1" />
                  <span>Live</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </div>
  );
};

export default Details;
